/* Model */
class DashboardConfigurationModel extends App.Models.BaseModel {
  modelUrl = 'DashboardConfiguration';
}

App.Models.DashboardConfiguration = DashboardConfigurationModel;

/* Collection */
class DashboardConfigurationCollection extends App.Collections.BaseCollection {
  url = 'DashboardConfiguration';
  model = App.Models.DashboardConfiguration;
}

App.Collections.DashboardConfigurations = DashboardConfigurationCollection;

/* Router */
class DashboardConfigurationRouter extends App.Routers.BaseRouter {
  constructor() {
    const entityName = 'DashboardConfiguration';
    const model = App.Models.DashboardConfiguration;
    const collectionClass = App.Collections.DashboardConfigurations;

    super(entityName, model, collectionClass);
  }

  afterCreateForm = function () {
    const dashboardConfigurationSection = document.querySelector("#DashboardConfiguration #DashboardConfiguration_btn_cancel");

    const syncDashboardsButton = document.createElement('input');
    syncDashboardsButton.setAttribute('type', 'button');
    syncDashboardsButton.setAttribute('value', Monet.I18n.getResourcesByKey(`DashboardConfiguration.syncDashboards`));
    syncDashboardsButton.className = 'MonetUIButton btn';
    syncDashboardsButton.id = 'SyncDashboardButton';

    const syncingIcon = document.createElement('i');
    syncingIcon.className = 'fa fa-refresh'

    const syncDashboardsContainer = document.createElement('div');
    syncDashboardsContainer.id = 'SyncDashboardsContainer';
    syncDashboardsContainer.appendChild(syncingIcon);
    syncDashboardsContainer.appendChild(syncDashboardsButton);

    dashboardConfigurationSection.before(syncDashboardsContainer);

    const renderErrorMessage = (message) => {
      const monetMessage = new Monet.Form.Messages.InlineMessage();
      const errorMessages = [];
      errorMessages.push(Monet.Form.Messages.mountErrorMessageObject(message))

      monetMessage.setScope(`#DashboardConfiguration #form_and_grid`);
      monetMessage.setInfoType('error');
      monetMessage.setMessage({ errorMessages });
      monetMessage.triggerMessage();
    }

    const syncDashboardOnClick = () => {
      const errorMessage = document.querySelector('#DashboardConfiguration .alert');
      errorMessage && (errorMessage.style.display = 'none');

      if (!Monet.Session.User.email) {
        renderErrorMessage('DashboardConfiguration.syncDashboards.emailMandatory');
      }
      else {
        syncingIcon.classList.add('loading');
        syncDashboardsButton.setAttribute('disabled', 'disabled');

        const ajax = new Monet.Ajax();
        ajax.url = `/ManagerDashboard/SyncWithAnalytics`;
        ajax.method = "POST";

        ajax.success = () => {
          syncingIcon.classList.remove('loading');
          syncDashboardsButton.removeAttribute('disabled');
        };

        ajax.error = () => {
          syncingIcon.classList.remove('loading');
          syncDashboardsButton.removeAttribute('disabled');
          renderErrorMessage('DashboardConfiguration.syncDashboards.error');
        };

        ajax.send();
      }
    };

    syncDashboardsButton.onclick = syncDashboardOnClick;
  }
}

App.Routers.DashboardConfiguration = DashboardConfigurationRouter;
